module.exports = ".example-container {\n  display: flex;\n  flex-direction: column; }\n"